import React, { useState, useEffect } from 'react';
import ShipmentsSrv from "../../../services/shipments_srv";
import ErrorMessage from '../../Shared/components/ErrorMessage';

function CartonDisplay(props) {

    const shipmentsSrv = new ShipmentsSrv(props.auth);
    //const [cartons, setCartons] = useState(null);
    const [displayError, setDisplayError] = useState('');

    useEffect(() => {
        // Some initialization logic here
        const getCartons = () => {
            setDisplayError('');
            shipmentsSrv.getByAuthorizationCode(props.SAN)
            .then((res) => { 
                if(res.status >= 200 && res.status <= 299){
                    return res.json() 
                }else{
                    throw Error(res.statusText);
                }
            })
            .then((result) => {
               if(result){
                    props.setCartons(result)
               }
            }).catch((error) =>{  
                console.log('error', error)           
                setDisplayError('Load Cartons Error:' + error.message);
            });       
        }
        getCartons();
      }, [props.SAN]);

    

    const createCartonRows = () =>{
        if(props.cartons !== null){
        return props.cartons.map( (carton) => {
           return (<tr key={carton.userShipmentId}>
                <td>
                    {carton.userShipmentId}
                </td>
                <td>
                    {carton.status}
                </td>
                <td>
                    {carton.products.length}
                </td>
                <td>
                    {carton.destinationLocation.name}
                </td>
       
            </tr>
                )});
            }
        else return null;
    }
    return (<>
    <ErrorMessage show={displayError !== ''?true:false} errorMessage={displayError}></ErrorMessage>
    <table className='carton-table'>
    <thead>
        <tr>
            <th>
                Carton ID
            </th>
            <th>
                Status
            </th>
            <th>
                Number of Locks
            </th>
            <th>
                Destination
            </th>
        </tr>
    </thead>
    <tbody >
        {createCartonRows()}
    </tbody>
    </table>
    </>)


}
export default CartonDisplay;